module.exports = __webpack_public_path__ + "img/ctrl-v-stub-0.b3007270.svg";